<ngx-charts-line-chart [results]="data" [scheme]="colorScheme" [view]="style.view" [legend]="style.legend"
    [gradient]="style.gradient" [showXAxisLabel]="style.showXAxisLabel" [showYAxisLabel]="style.showYAxisLabel"
    [xAxis]="style.xAxis" [yAxis]="style.yAxis" [xAxisLabel]="style.xAxisLabel" [yAxisLabel]="style.yAxisLabel"
    [legendPosition]="style.legendPosition" [legendTitle]="style.legendTitle" [curve]="curve">
    <ng-template #tooltipTemplate let-model="model">
        <div class="padding-6px">
            <span class="font-size-13px">{{ model?.series }} - {{model?.name}}</span>
            <br>
            <span class="font-size-16px">{{ model?.value }}</span>
        </div>
    </ng-template>
    <ng-template #seriesTooltipTemplate let-model="model">
        <div class="padding-6px">
            <div *ngFor="let item of model" class="align text-align-left">
                <mat-icon [style.color]="item.color" fxFlex class="align font-size18px">square</mat-icon>
                <span class="font-size-13px">{{ item?.series }}: {{ item?.value }}</span>
            </div>
        </div>
    </ng-template>
</ngx-charts-line-chart>